import swal from 'sweetalert2';
import * as HttpStatus from '../../../App_Data/HttpStatus';
import { ProcedureSignatureMandat } from '../../../App_Code/API';
import { isValidNumber } from 'libphonenumber-js';

export default async function creationProcedureSignature(NumRum, IdMandat, history) {
    const { value: formValues } = await swal.fire({
        title: 'Signature électronique',
        html:
      '<label for="nom">Nom </label><input id="nom" class="swal2-input" type="text">' +
      '<label for="prenom">Prénom </label><input id="prenom" class="swal2-input" type="text">' +
      '<label for="email">Email </label><input id="email" class="swal2-input" type="email">' +
      '<label for="tel">Téléphone portable</label><input id="tel" class="swal2-input" type="text">' +
	  '<label for="lieu">Lieu de signature </label><input id="lieu" class="swal2-input" type="text">',
        focusConfirm: false,
        preConfirm: () => [
            document.getElementById('nom').value,
            document.getElementById('prenom').value,
            document.getElementById('email').value,
            document.getElementById('tel').value,
			document.getElementById('lieu').value,
        ],
    });

    if (formValues) {
        if (formValues[0] === '' || formValues[1] === '' || formValues[2] === '' || formValues[3] === '') {
            swal('Attention!', 'Tous les champs sont obligatoires.', 'warning');
            return;
        }

        const regEmail = RegExp(/^.+@[^\.].*\.[a-z]{2,}$/);
        if (!regEmail.test(formValues[2])) {
            swal('Attention!', 'L\'email saisi n\'est pas correct.', 'warning');
            return;
        }

        const tel = formValues[3].replace(/\s/g, '');
        const telValide = (isValidNumber(tel, 'FR') || isValidNumber(tel));
        if (!telValide) {
            swal('Attention!', 'Le numéro de téléphonne saisi n\'est pas correct.', 'warning');
            return;
        }

        const signataire = {
            NumRum,
            DocMandat: IdMandat,
            Nom: formValues[0],
            Prenom: formValues[1],
            Email: formValues[2],
            Tel: tel,
			Lieu: formValues[4],
        };

        ProcedureSignatureMandat(signataire).then((response) => {
            if (response.status === HttpStatus.OK) {
                swal('Consultez vos e-mail', 'Pour finaliser la procedure, veuillez suivre les instructions du mail qui vous a été transmis.', 'warning');               
                history.push('/MesInformations', response.data);
                // history.push('/MesInformations/SaisieRIB/Signature', response.data);
            } else {
                swal({
                    type: 'error',
                    title: response.status === HttpStatus.BAD_REQUEST ? 'Attention ! ' : 'Erreur',
                    text: response.data && response.data.Message ? response.data.Message.replace(/["]+/g, '') : "Une erreur s'est produite lors de la création de la procédure.",
                });
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/MesInfos/Prelevement/FormProcedureSignature.js